export default __webpack_public_path__ + "static/media/sponsor-active.d20532ac.webp";